import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Divider,
  Prominences,
  Directions,
  Loading,
  Sizes,
  Icons,
} from '@sede-enterprise/shell-ds-react-framework';
import { MenuContainer, FloatingMenu } from './style';
import Button from '../../../UI/Button';
import { getCurrentGasDay } from '../../../utils/common/utils';
import { IFullState } from '../../../types/All.type';
import { getNominationStatus } from '../../../store/reducers/Dashboard';

const { ArrowLeft, ArrowRight } = Icons;

const DashboardDirectLinks: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(true);
  const isDashboard = location.pathname.split('/')[1] === 'dashboard';

  const {
    loadingDirectLinks,
    directLinkStatusFailed,
    directLinkStatus: {
      nominationStatus,
      entryCapacityStatus,
      exitCapacityStatus,
      tradeMatchingStatus,
      schedulingStatus,
    },
  } = useSelector((state: IFullState) => state.Dashboard);

  const data = [
    {
      title: 'Nominations',
      path: '/nominations/nominations',
      status: nominationStatus,
    },
    {
      title: 'Entry Capacity',
      path: '/sense-check/entry-capacity',
      status: entryCapacityStatus,
    },
    {
      title: 'Exit Capacity',
      path: '/sense-check/exit-capacity',
      status: exitCapacityStatus,
    },
    {
      title: 'Trade Matching',
      path: '/nominations/trade-matching-status',
      status: tradeMatchingStatus,
    },
    {
      title: 'Scheduling',
      path: '/nominations/matching-scheduling',
      status: schedulingStatus,
    },
  ];

  useEffect(() => {
    dispatch(getNominationStatus());
  }, []);

  const handleOpenClose = () => {
    setOpen(!open);
  };

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const renderButtonBackground = (value: boolean) => {
    if (directLinkStatusFailed) {
      return 'transparent';
    }
    return value ? 'green' : 'pink';
  };

  const renderMenu = () => (
    <MenuContainer>
      <div className='overview'>
        Overview for {getCurrentGasDay().format('DD MMM YYYY')}
      </div>
      {loadingDirectLinks && <Loading size={Sizes.Small} />}
      {data.map((item, index) => (
        <React.Fragment key={item.path}>
          <Button
            variant='transparent'
            size='small'
            onClick={() => handleNavigate(item.path)}
            className={renderButtonBackground(item.status)}
            data-testid='btn-link'
          >
            {item.title}
          </Button>
          {index !== data.length - 1 && (
            <Divider
              size={Sizes.Medium}
              direction={Directions.Vertical}
              prominence={Prominences.Strong}
            />
          )}
        </React.Fragment>
      ))}
    </MenuContainer>
  );

  const renderButtonContent = () => {
    const divider = (
      <Divider
        size={Sizes.Medium}
        direction={Directions.Vertical}
        prominence={Prominences.Strong}
      />
    );
    if (open) {
      return (
        <>
          <ArrowRight />
          {divider}
        </>
      );
    }
    return (
      <>
        {' '}
        {divider} <ArrowLeft />
      </>
    );
  };

  if (isDashboard) {
    return renderMenu();
  }

  return (
    <FloatingMenu>
      <Button
        className='btn-menu'
        onClick={handleOpenClose}
        data-testid='floating-button'
      >
        {renderButtonContent()}
      </Button>
      {open ? renderMenu() : null}
    </FloatingMenu>
  );
};

export default DashboardDirectLinks;
